import React from "react";
// import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { BreadCrumb } from "primereact/breadcrumb";
import { Menubar } from "primereact/menubar";
import FitIndiaSchoolLogo from "../assets/fit-india-school.svg";
import schoolImg from "../assets/school.jpeg";

function PublicHeader({ breadcrumb, title }) {
  const items = [
    {
      label: "HOME",
      url: "https://stjudesonline.in/",
    },
    {
      label: "SCHOOL & CAMPUS",
      items: [
        {
          label: "Aims of our Institution",
          icon: "pi pi-fw pi-stop",
          url: "http://stjudesonline.in/aims",
        },
        {
          label: "School Rules & Routine",
          icon: "pi pi-fw pi-stop",
          url: "http://stjudesonline.in/rules",
        },
        {
          label: "Academic Calendar",
          icon: "pi pi-fw pi-stop",
          url: "http://stjudesonline.in/calendar",
        },
        {
          label: "Curriculum",
          icon: "pi pi-fw pi-stop",
          url: "http://stjudesonline.in/curriculum",
        },
        {
          label: "School Facilities",
          icon: "pi pi-fw pi-stop",
          url: "http://stjudesonline.in/school-facilities",
        },
      ],
    },
    {
      label: "STUDENT LIFE",
      url: "#",
    },
    {
      label: "ACHIEVEMENTS",
      url: "http://stjudesonline.in/achivements",
    },
    {
      label: "ADMISSION",
      items: [
        {
          label: "Admission procedure",
          icon: "pi pi-fw pi-stop",
          url: "http://stjudesonline.in/admission-procedure",
        },
        {
          label: "Register",
          icon: "pi pi-fw pi-stop",
          url: "/registration/form",
        },
        {
          label: "Entrance Exam Result",
          icon: "pi pi-fw pi-stop",
          url: "/entranceExamResult",
        },
      ],
    },
    {
      label: "HAPPENINGS",
      url: "http://stjudesonline.in/updates",
    },
    {
      label: "TESTIMONAILS",
      items: [
        {
          label: "Parents Speak",
          icon: "pi pi-fw pi-stop",
          url: "http://stjudesonline.in/parents-speak",
        },
        {
          label: "Voices of Ex-Judians",
          icon: "pi pi-fw pi-stop",
          url: "http://stjudesonline.in/voices-of-ex-judians",
        },
      ],
    },
    {
      label: "ALUMNI",
      url: "/AlumniForm",
    },
    {
      label: "CONTACT US",
      url: "http://stjudesonline.in/contact-us",
    },
  ];

  const home = { label: "Home", url: "https://stjudesonline.in/" };

  return (
    <header>
      <div className="col-md-12 text-center top-menu">
        <div className="row p-20">
          <div className="col-12 md:col-12 xl:col-6" style={{ width: "50%" }}>
            <div className="row">
              <div className="mr-3">
                <i className="pi pi-phone  mr-2 nav-icon"></i>
                <a href="tel:04266 275709 (32 Lines)">
                  04266 275709 (32 Lines)
                </a>
              </div>
              <div className="">
                <i className="pi pi-phone  mr-2 nav-icon"></i>
                <a href="tel:04266 275809 (32 Lines)">
                  04266 275809 (32 Lines)
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-12 xl:col-6" style={{ width: "50%" }}>
            <div className="row pull-right">
              <a href="https://portal.stjudesonline.in/">
                {/* <i className="pi pi-phone" style={{ fontSize: ".8rem" }}></i> */}
                <span className="">
                  <span>Login</span>
                </span>
              </a>

              <a
                href="https://quickpay.stjudesonline.in/"
                className="quickpay ml-2"
                target="_blank"
              >
                <span className="unit-left">
                  <span className="">|&nbsp;&nbsp;</span>
                </span>
                <span className="unit-body">
                  <span>Quick Pay</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div className="row main-nav-bar">
          <div className="school-logo">
            <a href="http://www.stjudesonline.in">
              <img
                src={require("../assets/logo.png")}
                alt="Logo"
                width={"100%"}
              />
            </a>
          </div>
          <div className="fit-india">
            <div className="float-right">
              <a href="http://www.stjudesonline.in">
                <img src={FitIndiaSchoolLogo} alt="Logo" width={"70%"} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="sub-nav-bar-outer"></div>
      <div
        className=""
        // style={{
        //   background: "#838fa6",
        // }}
      >
        <div className="sub-nav-bar">
          <Menubar model={items} />
        </div>
      </div>

      <section
        class="section parallax-container bg-black"
        data-parallax-img={schoolImg}
      >
        <div class="material-parallax parallax">
          <img
            src={schoolImg}
            alt=""
            style={{
              display: "block",
              transform: "translate3d(-50%, 129px, 0px)",
            }}
          />
        </div>
        <div class="parallax-content section section-sm context-dark overlay-5">
          <div class="container">
            <div class="row justify-content-sm-center justify-content-lg-start">
              <div class="col-md-12 offset-top-10 text-center w-full">
                <div className="public-title">
                  <div className="main-title">
                    <h1>{title}</h1>
                  </div>
                </div>
                <div className="public-bread-crumbs">
                  <div className="bread-crumbs">
                    <BreadCrumb model={breadcrumb} home={home} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className=""
        style={{
          position: "relative",
          // top: "-15px",
        }}
      ></div>
    </header>
  );
}

export default PublicHeader;
